import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { formatIDR, formatDateTime } from '../../lib/format';
import AdminLayout from '../../components/AdminLayout';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { StatusBadge } from '../../components/StatusBadge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../../components/ui/dialog';
import { Eye } from 'lucide-react';

export default function AdminPayments() {
  const [payments, setPayments] = useState([]);
  const load = () => api.get('/admin/payments').then(r => setPayments(r.data.payments)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const verify = async (id, action) => {
    try { await api.post(`/admin/payments/${id}/verify`, { action, reason: action === 'reject' ? 'Bukti tidak valid' : '' });
      toast.success(action === 'approve' ? 'Pembayaran disetujui & membership aktif' : 'Pembayaran ditolak'); load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Gagal'); }
  };

  const backend = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem('gta_token');

  return (
    <AdminLayout title="Verifikasi Pembayaran">
      <Card className="p-0 overflow-hidden">
        <div className="overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Member</TableHead><TableHead>Jumlah</TableHead><TableHead>Ref</TableHead><TableHead>Bukti</TableHead><TableHead>Status</TableHead><TableHead>Waktu</TableHead><TableHead>Aksi</TableHead></TableRow></TableHeader>
          <TableBody>
            {payments.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-8">Belum ada pembayaran</TableCell></TableRow>}
            {payments.map(p => (
              <TableRow key={p.payment_id}>
                <TableCell><div className="font-medium">{p.user_name}</div><div className="text-xs text-muted-foreground">{p.user_email}</div></TableCell>
                <TableCell className="tabular-nums">{formatIDR(p.amount)}</TableCell>
                <TableCell className="font-mono text-xs">{p.reference_number}</TableCell>
                <TableCell>{p.proof_of_payment ? (
                  <Dialog><DialogTrigger asChild><Button variant="outline" size="sm" data-testid={`view-proof-${p.payment_id}`}><Eye className="h-3.5 w-3.5" /></Button></DialogTrigger>
                    <DialogContent><DialogHeader><DialogTitle>Bukti Transfer</DialogTitle></DialogHeader>
                      <img src={`${backend}/api/files/${p.proof_of_payment}?auth=${token}`} alt="proof" className="w-full rounded-lg" onError={(e)=>{e.target.style.display='none';e.target.insertAdjacentHTML('afterend','<a href=\''+backend+'/api/files/'+p.proof_of_payment+'?auth='+token+'\' target=_blank class=underline>Buka file</a>');}} />
                    </DialogContent>
                  </Dialog>
                ) : <span className="text-xs text-muted-foreground">-</span>}</TableCell>
                <TableCell><StatusBadge status={p.status} /></TableCell>
                <TableCell className="text-xs text-muted-foreground">{formatDateTime(p.created_at)}</TableCell>
                <TableCell>
                  {['SUBMITTED','PENDING'].includes(p.status) && (
                    <div className="flex gap-1">
                      <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => verify(p.payment_id, 'approve')} data-testid={`approve-payment-${p.payment_id}`}>Setujui</Button>
                      <Button size="sm" variant="outline" onClick={() => verify(p.payment_id, 'reject')} data-testid={`reject-payment-${p.payment_id}`}>Tolak</Button>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </div>
      </Card>
    </AdminLayout>
  );
}
